import { CargoTypeEnum } from "../enums/cargoTypeEnum";
import { CargoTypeData } from "../models/features/loadingInput/cargoTypeData";

export const cargoTypeDefaultValues = [
    {
        cargoType: CargoTypeEnum.CardboardBox,
        quantity: 1,
        length: 0,
        width: 0,
        height: 0,
        weight: 0
    } as CargoTypeData,
    {
        cargoType: CargoTypeEnum.EuroPallet,
        quantity: 1,
        length: 120,
        width: 80,
        height: 0,
        weight: 0
    } as CargoTypeData,
    {
        cargoType: CargoTypeEnum.PalletFin,
        quantity: 1,
        length: 120,
        width: 100,
        height: 0,
        weight: 0
    } as CargoTypeData,
    {
        cargoType: CargoTypeEnum.PalletInd,
        quantity: 1,
        length: 120,
        width: 120,
        height: 0,
        weight: 0
    } as CargoTypeData,
    {
        cargoType: CargoTypeEnum.Other,
        quantity: 1,
        length: 0,
        width: 0,
        height: 0,
        weight: 0
    } as CargoTypeData
]